import type { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import type { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import { scopeAccessorials } from "@/Data/scopeAccessorials";

export function accessorialFromType(
  scope: LocationContext | undefined,
  locationType: LocationType | undefined,
  type: string,
) {
  const a = scopeAccessorials(scope, locationType).find(
    (accessorial) => accessorial.type === type,
  );

  if (a === undefined) {
    return undefined;
  }

  return a;
}
